<template>
  <template v-if="isLoaded">
    <div v-if="Article">
    <div :class="'glasses-product-detail' + (hasMood() ? ' has-mood' : '') + ' ' + Article.brand.toLowerCase() + ' glasses-product-detail-site-' + brand">
      <!-- Hauptbühne Spalte links -->
      <div class="glasses-product-detail-stage">
        <!-- Social Buttons - Layout Bottom-->
        <div class="glasses-product-detail-social" v-if="getLayout('socialbuttons') == 'top'">
          <div class="gpdp-col">
            <share-buttons v-if="Article" :ArtNr="Article.article_nr" :itemView='currentView'
                           :ColorNr="CurrentColor.color_nr"
                           :translate="translate"></share-buttons>
          </div>
        </div>
        <transition-group name="fade" :key="colorNr">
          <div v-if="isLoaded" :key="currentView">
            <component GlassesList.value.length :is='ItemStage' :itemView='currentView'
                       :active="color == CurrentColor " :Glassitem="Article" v-for="(color,index) in Colors"
                       :key="color.color_nr" :color="color" :currentColor="CurrentColor"
                       :idx="index"/>
          </div>
        </transition-group>
      </div>
      <!-- Hauptbühne ENDE -->
      <!-- Toolbar Spalte rechts -->
      <div class="glasses-product-detail-toolbar">
        <!-- Toolbar HEADER -->
        <div class="gpdp-row gpdp-col glasses-product-detail-header-container">
        <div class="glasses-product-detail-header gpdp-row gpdp-mobile-order-1" id="glasses-product-detail-header">
          <!-- Select für Farbe -->
          <div class="glasses-product-detail-colorselect">
            <div class="detail-header-colors-label">
              <h4 class="gpdp-h4">{{ translate('Colours') }}</h4>
            </div>
            <colorselect class="color-select"
                         @colorClicked="(newColorIndex) => colorIdx = newColorIndex"
                         :Layout="getLayout('colorselect')"  :Colors="Colors"/>
          </div>
          <!-- Farbselect ENDE -->
          <!-- Produktkennung anzeigen: Artikelnr und Farbnnr -->
          <div class="glasses-product-detail-identifier">
            <h5 class="detail-header-identifier-artnr-heading">Artikelnummer:</h5>
            <div v-if="Article" class="detail-header-identifier-artnr">
              <div class="detail-header-identifier-artnr-text">
              {{
                Article.article_nr
              }}
              </div>
            </div>
            <div class="detail-header-identifier-colnr">
              col. <span class="inline-fade" v-for="(color) in Colors"
                         :key="color.color_nr">
                  <span v-if="CurrentColor.color_nr === color.color_nr">{{ color.color_nr }}</span>
            </span>
            </div>
          </div>
          <!-- Produktkennung ENDE -->
        </div>
        <!-- Toolbar HEADER ENDE-->
        <!-- Wahl der Ansicht: Normal, Vorderansicht, Mood -->
        <view-select v-if="hasViewVariants()"
                     @viewClicked="(newView) => currentView = newView.toUpperCase()"
                     :Color="CurrentColor" :Glassitem="Article" :viewVariants="viewVariants()"/>
        </div>
        <!-- Produktinformationen -->
        <div class="glasses-product-detail-product-information gpdp-row">
          <div class="gpdp-col">
            <item-properties :GlassItem="getArticle()" :translate="translate" :icon="getDecoration('infoBtn')" :brand-site="brand" />
            <div class="glasses-product-detail-social-heading">
              <h4 class="gpdp-h4">{{ translate('Share') }}</h4>
            </div>
            <div class="gpdp-col gpdp-lined-bottom product-detail-properties-subline"></div>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- Social Buttons - Layout Bottom-->
        <div class="glasses-product-detail-social" v-if="getLayout('socialbuttons') != 'top'">
          <div class="gpdp-col">
            <share-buttons v-if="Article" :ArtNr="Article.article_nr" :itemView='currentView'
                           :ColorNr="CurrentColor.color_nr"
                           :translate="translate"></share-buttons>
          </div>
        </div>
        <!-- additional Buttons -->
        <div class="glasses-product-detail-buttons">
          <div class="gpdp-col">
            <!-- wishlist Button, so konfiguriert -- Funktionalität wird von der Wishlist-App zur Verfügung gestellt-->
            <div v-if="getLayout('wishlistbutton') == 'show'" >
            <a class="btn btn-eon btn-primary btn-middle eon-add-wishlist-btn" :data-artnr="Article.article_nr" :data-color-code="CurrentColor.color_nr" href="#" id="eon-wishlist-btn">
              <font-awesome-icon class="usertool-button-decoration" :icon="getDecoration('favoriteBtn')"/>
              {{ translate('wishlist add') }}</a>
            </div>
            <!-- PDF-Info Download-Button, so konfiguriert  -- Funktionalität wird von der Wishlist-App zur Verfügung gestellt-->
            <div v-if="getLayout('infodownload') == 'show'" >
            <a class="btn btn-eon btn-inverse btn-middle eon-print-info-btn" :data-artnr="Article.article_nr" :data-color-code="CurrentColor.color_nr" id="eon-model-info-btn">
              <font-awesome-icon class="usertool-button-decoration" :icon="getDecoration('infoDownloadBtn')"/> {{ translate('infos download') }}</a>
            </div>
            <div>
              <!-- Link zur Optikersuche  -->
            <a :class="config.buttonstyles + ' btn-glasses'"
               :href='"/" + language + "/" + translate("optician_link")'>
              <font-awesome-icon class="usertool-button-decoration" :icon="getDecoration('opticianBtn')"/>
              {{ translate('Optiker finden') }}
            </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Toolbar Ende -->
    </div>
    </div>
    <div v-else>
      <h3>Page not found</h3>
    </div>
  </template>
  <template v-else>
    <div v-if="!Article">
      <h3>Product not found</h3>
    </div>

  </template>
</template>

<style scoped></style>
<script>
import {ref, computed} from 'vue'
import {fetchJsonObject} from '@/composable/fetchJsonObject'
import {getModelFromUri, getLang, preloadImages} from '@/composable/eonUtils'
import ItemStage from '@/components/glassitem-stage'
import ViewSelect from '@/components/glassitem-viewselect'
import Colorselect from '@/components/glassitem-colorselect'
import ItemProperties from '@/components/glassitem-properties'
import ShareButtons from '@/components/glassitem-sharebuttons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'

/* import all the icons in Free Solid, Free Regular, and Brands styles */
import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

export default {

  inheritAttrs: false,
  name: 'App',
  props: {
    config: Object,
  },

  setup(props) {
    // Artikelnummer und Farbnummer aus der URL holen
    let ArtNr, colorNr;
    [ArtNr, colorNr] = getModelFromUri() ? getModelFromUri() : [undefined, undefined]
    // Aktuelle Ansicht auf der Stage - Normal, Frontansicht, Moodbild
    const currentView = ref(props.config.initialview)
    // Sprache aus der URL erkennen und in Variable merken
    const language = computed(() => {
      return getLang(props.config)
    })
    // Brand-Bezeichner (mini, brendel, humphreys, jos, titanflex, freigeist) aus der Config entnehmen
    // (data-Attribut data-cfg-brand)
    const brand = computed(() => {
      return props.config.brand
    })

    const Layouts = computed(() => {
      let layout = {};
      try {
        layout = JSON.parse(props.config.layouts);
      } catch (e) {
        console.log('no layout set');
      }

      return layout
    })
    const Decorations = computed(() => {
      let decorations = {};
      if (props.config.decorations && typeof props.config.decorations === "object") {
        return props.config.decorations
      }
      try {
        decorations = JSON.parse(props.config.decorations);
      } catch (e) {
        console.log('no decorations set');
      }
      return decorations
    })

    // Aktuelles Farben-Objekt - Default
    const CurrentColor = ref({
      color_nr: 10,
      image: "",
      group: 1,
      class: "",
      imageMissing: false,
      hasMood: false,
      hasFront: false
    })

    // Liste der Farben-Objekte des Artikels
    const Colors = ref([]);

    // Aktueller Index der Farben Liste (Default 0)
    const colorIdx = ref(-1)
    // Wenn das Json geladen ist..
    const isLoaded = computed(
      () => ArtNr !== undefined &&  colorNr !== undefined && GlassesList.value.length > 1
    )
    // Initiales View aus der Config laden
    const initialView = computed(
      () => props.config.initialview
    )
    // Das Json als Objelladen
    const {errorOnLoad, GlassesList, translation} = fetchJsonObject()
    // Artikel nach Artikelnr in der URL aus dem Objekt filtern
    const Article = computed(
      () => {
        return GlassesList.value.filter(glass => glass.article_nr === ArtNr.toLowerCase())[0]
      }
    )
    return {
      isLoaded,
      errorOnLoad,
      language,
      translation,
      GlassesList,
      Article,
      Colors,
      ArtNr,
      colorNr,
      CurrentColor,
      colorIdx,
      currentView,
      ItemStage,
      initialView,
      brand,
      Layouts,
      Decorations
    }
  },
  created: function () {
    this.getArticle()

  },
  methods: {
    getArticle: function () {
      if (!this.ArtNr) return this.Article
      this.Article = this.GlassesList.filter(glass => glass.article_nr === this.ArtNr.toLowerCase())[0]
      // Falls kein Artikel anhand der URL gefunden wurde...
      if (!this.Article) {
        // wenn der Artikel (noch) nicht geladen werden kann
        // können wir an der Stelle erst mal nicht weiter machen
        return this.Article
      }
      // weitere Eigenschaften initiieren
      this.Colors = this.Article.colors

      this.Article.hasMoodClass = this.hasMood() ? 'has-mood' : 'has-to-mood'
      // In der URL enthaltene Farbe finden
      if(this.colorIdx < 0) {
        this.Article.colors.forEach((col,index) => {
          if(col.color_nr === this.colorNr) {
            this.colorIdx = index
          }
        })
      }
      // Falls diese nicht existiert, einfach die erste Farbe nehmen
      if(this.colorIdx < 0 ) this.colorIdx = 0
      this.CurrentColor = this.Article.colors[this.colorIdx]
      // Sollte die Config eine Umsortierung der Views verlangen (z.B. FRNT zuerst) und dieses View
      // nicht verfügbar sein, muss currentView auf "" gesetzt werden
      if(this.currentView === "FRNT" && !this.hasFront() || this.currentView === "MOOD" && !this.hasMood()) {
        this.currentView = "";
      }
      // Bilder werden vorgeladen
      preloadImages(this.config.glassesBaseUrl, this.Article)
      return this.Article;

    },
    /**
     * Ermittelt ein Layout für eine Brand-Site aus der Config
     * @param key - Key
     * @returns {*|string} - Wert
     */
    getLayout: function(key) {
      return (key in this.Layouts) ? this.Layouts[key ] : 'default'
    },
    /**
     * Ermittelt eine "Dekoration" (i.d.R. css-Klassen) aus der Config
     * @param key - Key
     * @returns {*|string} - Wert
     */
    getDecoration: function(key) {
      return (key in this.Decorations) ? this.Decorations[key ] : 'default'
    },
    /**
     * Steht für die aktuelle Brille eine Mood- oder Frontansicht zur Verfügung?
     * @returns boolean
     */
    hasViewVariants: function () {
      const col = this.Article && this.Article.colors.find(color => {
          return color.hasMood || color.hasFront
        }
      )
      return col
    },
    /**
     * Steht für die aktuelle Brille eine Moodansicht zur Verfügung?
     * @returns boolean
     */
    hasMood: function () {
      const col = this.Article && this.Article.colors.find(color => {
          return color.hasMood
        }
      )
      return !!col
    },
    /**
     * Steht für die aktuelle Brille eine Frontansicht zur Verfügung?
     * @returns boolean
     */
    hasFront: function () {
      const col = this.Article && this.Article.colors.find(color => {
          return color.hasFront
        }
      )
      return !!col
    },
    /**
     * Gibt eine Liste der View-Varianten zurück
     * @returns {string[]}
     */
    viewVariants() {
      const viewVariants = [""]

      if(this.CurrentColor.hasFront) {
        viewVariants.push('FRNT')
      }
      if (this.CurrentColor.hasMood) {
        viewVariants.push('MOOD')
      }
      viewVariants.sort((a, b) => {
        if (a ===  this.initialView) {
          return -1;
        } else {
          if (b ===  this.initialView) {
            return 1;
          }
        }
        return 0;
      })
      return viewVariants
    },

    /**
     * Übersetze einen String. str ist ein Key im Translation-Objekt
     * @param str - Der zu übersetzende String|Key im Translation-Objekt
     * @returns {string}
     */
    translate: function (str) {
      const language = this.language
      if ((language in this.translation) && (str in this.translation[language])) {
        return this.translation[language][str]
      }
      return str;
    },
  },
  components: {
    ItemStage,
    Colorselect,
    ViewSelect,
    ItemProperties,
    FontAwesomeIcon,
    ShareButtons
  }
}
</script>

<style scoped>
@import "css/product-detail.css";
</style>
<script setup lang="ts">
</script>
